var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3956 14.8609C14.6625 14.8609 16.2963 14.8609 17.3108 13.8456C18.3261 12.8311 18.3261 11.1973 18.3261 7.93043C18.3261 4.6636 18.3261 3.02975 17.3108 2.01531C16.2963 1 14.6625 1 11.3956 1H7.93043C4.6636 1 3.02975 1 2.01531 2.01531C1 3.02975 1 4.6636 1 7.93043C1 11.1973 1 12.8311 2.01531 13.8456C2.581 14.4121 3.33902 14.6625 4.46521 14.7725",
    stroke: "#626D77",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3956 14.8609C10.3248 14.8609 9.14494 15.294 8.06812 15.8528C6.33725 16.7511 5.47181 17.2007 5.04559 16.914C4.61937 16.6281 4.69993 15.7402 4.86193 13.9651L4.89832 13.5614",
    stroke: "#626D77",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookCommentIcon);
export default __webpack_public_path__ + "static/media/facebook-comment-icon.59aca019dbc1a68505f08fe200819d6b.svg";
export { ForwardRef as ReactComponent };